var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-TextField__Resizer",
    attrs: {
      "aria-hidden": ""
    }
  }, [_c('div', {
    ref: "dummyInput",
    staticClass: "Polaris-TextField__DummyInput",
    domProps: {
      "innerHTML": _vm._s(_vm.finalContents)
    }
  }), _vm._v(" "), (_vm.minimumLines) ? _c('div', {
    staticClass: "Polaris-TextField__DummyInput",
    domProps: {
      "innerHTML": _vm._s(_vm.minimumLinesContent)
    }
  }) : _vm._e()])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-02e09a10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e09a10","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisTextFieldResizer.vue
// module id = 301
// module chunks = 0